import { render, staticRenderFns } from "./ProvincialMap.vue?vue&type=template&id=c855813a&"
import script from "./ProvincialMap.vue?vue&type=script&lang=js&"
export * from "./ProvincialMap.vue?vue&type=script&lang=js&"
import style0 from "./ProvincialMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProvincialMap.vue"
export default component.exports